(function () {
  if (window.torvaCustomerStoryTrackingReady) {
    return;
  }

  window.torvaCustomerStoryTrackingReady = true;

  var attributionKey = 'torva_customer_story_origin';
  var attributionLifetime = 30 * 60 * 1000;
  var story = document.querySelector('.customer-story');

  function sendEvent(eventName, parameters) {
    var eventParameters = Object.assign(
      {
        send_to: 'G-3MFV62R9VK',
        transport_type: 'beacon',
      },
      parameters || {}
    );

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, eventParameters);
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, eventParameters));
  }

  function readAttribution() {
    try {
      var storedValue = window.sessionStorage.getItem(attributionKey);

      if (!storedValue) {
        return null;
      }

      var attribution = JSON.parse(storedValue);

      if (!attribution.expires_at || attribution.expires_at < Date.now()) {
        window.sessionStorage.removeItem(attributionKey);
        return null;
      }

      return attribution;
    } catch (error) {
      return null;
    }
  }

  function writeAttribution(storyId, storyAction) {
    try {
      window.sessionStorage.setItem(
        attributionKey,
        JSON.stringify({
          story_id: storyId,
          story_action: storyAction,
          expires_at: Date.now() + attributionLifetime,
        })
      );
    } catch (error) {
      return;
    }
  }

  function getStoryContext(element) {
    var contextRoot = element.closest('.customer-story, .customer-stories-index');

    return {
      root: contextRoot,
      storyId: element.dataset.storyId || (contextRoot && contextRoot.dataset.storyId) || '',
      buildType: (contextRoot && contextRoot.dataset.storyBuildType) || '',
      vehicle: (contextRoot && contextRoot.dataset.storyVehicle) || '',
    };
  }

  document.addEventListener(
    'click',
    function (event) {
      var trackedLink = event.target.closest('a[data-story-area][data-story-action]');

      if (!trackedLink) {
        return;
      }

      var context = getStoryContext(trackedLink);
      var storyAction = trackedLink.dataset.storyAction || '';
      var eventParameters = {
        story_id: context.storyId,
        story_area: trackedLink.dataset.storyArea || '',
        story_action: storyAction,
        story_build_type: context.buildType,
        story_vehicle: context.vehicle,
        product_handle: trackedLink.dataset.productHandle || '',
        link_url: trackedLink.href,
        content_group: 'customer_stories',
      };

      if (context.root) {
        context.root.dataset.storyLastAction = storyAction;
      }

      if (storyAction === 'dealer_program' || storyAction === 'product_documents') {
        writeAttribution(context.storyId, storyAction);
      }

      sendEvent('torva_customer_story_click', eventParameters);
    },
    true
  );

  function copyStoryUrl(url) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(url).then(function () {
        return 'copy_link';
      });
    }

    return new Promise(function (resolve, reject) {
      var textArea = document.createElement('textarea');
      textArea.value = url;
      textArea.setAttribute('readonly', '');
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.select();

      try {
        var copied = document.execCommand('copy');
        document.body.removeChild(textArea);

        if (copied) {
          resolve('copy_link');
          return;
        }

        reject(new Error('Copy failed'));
      } catch (error) {
        document.body.removeChild(textArea);
        reject(error);
      }
    });
  }

  document.addEventListener('click', function (event) {
    var shareButton = event.target.closest('[data-story-share]');

    if (!shareButton) {
      return;
    }

    var storyUrl = shareButton.dataset.storyUrl || window.location.href;
    var storyTitle = shareButton.dataset.storyTitle || document.title;
    var status = document.querySelector('[data-story-share-status]');
    var sharePromise;

    if (navigator.share) {
      sharePromise = navigator
        .share({ title: storyTitle, url: storyUrl })
        .then(function () {
          return 'native';
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') {
            return null;
          }

          return copyStoryUrl(storyUrl);
        });
    } else {
      sharePromise = copyStoryUrl(storyUrl);
    }

    sharePromise
      .then(function (method) {
        if (!method) {
          return;
        }

        if (status) {
          status.textContent = method === 'native' ? 'Story shared.' : 'Story link copied.';
        }

        sendEvent('share', {
          method: method,
          content_type: 'customer_story',
          item_id: story ? story.dataset.storyId : '',
          content_group: 'customer_stories',
        });
      })
      .catch(function () {
        if (status) {
          status.textContent = 'Unable to copy the link.';
        }
      });
  });

  window.torvaTrackCustomerStoryLeadSuccess = function (leadType) {
    var attribution = readAttribution();

    if (!attribution || !leadType) {
      return false;
    }

    var completionKey = attributionKey + '_completed_' + leadType;

    try {
      if (window.sessionStorage.getItem(completionKey) === attribution.story_id) {
        return false;
      }

      window.sessionStorage.setItem(completionKey, attribution.story_id);
    } catch (error) {
      return false;
    }

    sendEvent('generate_lead', {
      lead_type: leadType,
      source_content: 'customer_story',
      source_story_id: attribution.story_id,
      source_story_action: attribution.story_action,
      content_group: 'customer_stories',
    });

    return true;
  };

  document.addEventListener('torva:lead:success', function (event) {
    var leadType = event.detail && event.detail.leadType;
    window.torvaTrackCustomerStoryLeadSuccess(leadType);
  });

  if (!story) {
    readAttribution();
    return;
  }

  story.dataset.storyTrackingReady = 'true';

  sendEvent('torva_customer_story_view', {
    story_id: story.dataset.storyId || '',
    story_build_type: story.dataset.storyBuildType || '',
    story_vehicle: story.dataset.storyVehicle || '',
    content_group: 'customer_stories',
  });

  var activeSeconds = 0;
  var deepestScroll = 0;
  var engagedSent = false;

  function updateScrollDepth() {
    var storyTop = story.getBoundingClientRect().top + window.scrollY;
    var viewportBottom = window.scrollY + window.innerHeight;
    var currentDepth = (viewportBottom - storyTop) / story.offsetHeight;

    deepestScroll = Math.max(deepestScroll, Math.min(1, Math.max(0, currentDepth)));

    if (!engagedSent && activeSeconds >= 30 && deepestScroll >= 0.5) {
      engagedSent = true;
      story.dataset.storyEngaged = 'true';
      sendEvent('torva_customer_story_engaged', {
        story_id: story.dataset.storyId || '',
        story_build_type: story.dataset.storyBuildType || '',
        story_vehicle: story.dataset.storyVehicle || '',
        active_seconds: activeSeconds,
        scroll_percent: Math.round(deepestScroll * 100),
        content_group: 'customer_stories',
      });
    }
  }

  window.addEventListener('scroll', updateScrollDepth, { passive: true });
  window.addEventListener('resize', updateScrollDepth);
  updateScrollDepth();

  window.setInterval(function () {
    if (document.visibilityState === 'visible') {
      activeSeconds += 1;
      updateScrollDepth();
    }
  }, 1000);
})();
